import { api } from './client.js';

const root = '/admin/privacy';

export const privacyApi = {
  overview: () => api.get(`${root}/overview`),
  listRegister: (params) => api.get(`${root}/register`, { query: params }),
  getRegister: (id) => api.get(`${root}/register/${id}`),
  createRegister: (body) => api.post(`${root}/register`, body),
  updateRegister: (id, body) => api.patch(`${root}/register/${id}`, body),
  removeRegister: (id) => api.delete(`${root}/register/${id}`),
  exportRegister: () => api.get(`${root}/register/export`, { raw: true }),
  listConsents: (params) => api.get(`${root}/consents`, { query: params }),
  listDataExports: (params) => api.get(`${root}/data-exports`, { query: params }),
  listErasures: (params) => api.get(`${root}/erasures`, { query: params })
};
